import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { GatewayProvider, GatewayDest } from 'react-gateway';

import { postPageResized } from '../../../post-page/actions/post-page-resize';
import { isEditor, getViewMode } from '../../selectors/view-mode-selectors';
import WindowResizeListener from '../window-resize-listener';
import AppWrapper from '../app-wrapper';
import MessageRoot from '../../containers/message-root';
import DemoMessageRoot from '../../containers/demo-message-root';
import ModalLoader from '../../containers/modal-loader';
import AccessibilityListener from '../accessibility-listener';
import { isInWix } from '../../services/is-in-wix';
import { isPostPageBundle } from '../../services/section-route-utils';
import { getPostPageEnabled } from '../../selectors/app-data-selectors';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import styles from './app.scss';

export class AppMobile extends Component {
  componentDidMount() {
    if (!isInWix()) {
      document.documentElement.classList.add('enable-scroll');
    }

    this.appWidth = window.innerWidth;
  }

  handleResize = () => {
    const { isEditor, isPostPageBundle, postPageResized, viewMode } = this.props;

    if (!isEditor) {
      return;
    }

    const widthChanged = this.appWidth !== window.innerWidth;

    if (isPostPageBundle && widthChanged) {
      postPageResized({ viewMode, width: window.innerWidth, buildertype: 'mobile' });
      this.appWidth = window.innerWidth;
    }
  };

  renderResizeListener() {
    return this.props.isEditor && <WindowResizeListener onResize={this.handleResize} />;
  }

  render() {
    const { main, children, mobileHeader, mobileMenu, isOneApp, isPostPageEnabled } = this.props;
    return (
      <GatewayProvider>
        <AppWrapper
          className={classNames(
            styles.app,
            'app-mobile',
            isPostPageEnabled ? 'blog-background-color' : 'blog-card-background-color',
          )}
        >
          {!isPostPageEnabled && <div className={styles.backgroundOverlay} />}
          {this.renderResizeListener()}
          <AccessibilityListener />
          <MessageRoot />
          <DemoMessageRoot />
          <ModalLoader />
          <div id="content-wrapper" className={classNames(styles.scrollable, 'app-mobile__scrollable')}>
            {mobileHeader &&
              React.cloneElement(mobileHeader, {
                menu: mobileMenu,
                hideNavBar: isOneApp,
              })}
            {main && React.cloneElement(main, { children })}
          </div>
          <GatewayDest name="footer" />
          <GatewayDest name="floating-action-button" />
          <GatewayDest name="tooltip" />
        </AppWrapper>
      </GatewayProvider>
    );
  }
}

AppMobile.propTypes = {
  categories: PropTypes.array,
  children: PropTypes.node,
  isEditor: PropTypes.bool,
  isOneApp: PropTypes.bool,
  isPostPageBundle: PropTypes.bool,
  isPostPageEnabled: PropTypes.bool,
  main: PropTypes.node,
  mobileHeader: PropTypes.node,
  mobileMenu: PropTypes.node,
  postPageResized: PropTypes.func,
  viewMode: PropTypes.string,
};

const mapStateToProps = state => ({
  isEditor: isEditor(state),
  categories: state.categories,
  isOneApp: isOneApp(state),
  isPostPageEnabled: getPostPageEnabled(state),
  viewMode: getViewMode(state),
  isPostPageBundle: isPostPageBundle(),
});

const mapDispatchToProps = {
  postPageResized,
};

export default flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AppMobile);
